export default [{
	titulo: 'Concursos 2023',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/concursos-2023',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]